import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Global scroll reset: every route change opens the new page at the very top. The Coach OS and the
// client portal both scroll at the window/document level, so a single window.scrollTo(0,0) on pathname
// change fixes the SPA "opens halfway down" problem everywhere — no per-page fixes needed.
//
// Opt-out: navigate with state { preserveScroll: true } for the rare flow that intentionally keeps
// position. Only the PATHNAME is watched, so query-string/filter changes on the same page don't yank
// the user back to the top.
export default function ScrollToTop() {
  const { pathname, state } = useLocation();

  useLayoutEffect(() => {
    // Stop the browser from auto-restoring the previous scroll on push navigations.
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    if (state && state.preserveScroll) return;
    window.scrollTo(0, 0);
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
    // Keyed on pathname only: same-path state/query updates (e.g. a page persisting its filters)
    // must NOT yank the user back to the top. `state` is read fresh from the render closure.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}
